import _CalendarGroup from 'owa-service/lib/contract/CalendarGroup';
import Calendar from '../store/schema/Calendar';
import CalendarEntryExtended from '../store/schema/CalendarGroupExtended';
import CalendarGroupExtended from '../store/schema/CalendarGroupExtended';
import CalendarId from '../store/schema/CalendarId';
import { CalendarCacheStoreData } from '../store/schema/CalendarCacheStoreData';
import CalendarFolder from 'owa-service/lib/contract/CalendarFolder';
import CalendarFolderTypeEnum from 'owa-service/lib/contract/CalendarFolderTypeEnum';
import {
    getCalendarDisplayName,
    getCalculatedFolderId,
    getCalendarGroupKey,
} from 'owa-calendar-cache';
import { getUserMailboxInfo } from 'owa-client-ids';
import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';
import { shouldAddCalendarToCache } from '../utils/shouldAddCalendarToCache';

export function convertToCalendarCacheStoreData(
    groups: _CalendarGroup[],
    folders: CalendarFolder[],
    mailboxId?: string
): CalendarCacheStoreData {
    let defaultCalendar: Calendar;
    let calendarEntryMapping: { [key: string]: CalendarEntryExtended } = {};
    let calendarFolderMapping: { [key: string]: CalendarFolder } = {};
    let folderIdMapping: { [key: string]: CalendarId } = {};
    let calendarGroupMapping: { [key: string]: CalendarGroupExtended } = {};
    let calendarIdToChangeKeyMapping: { [key: string]: string } = {};
    let calendarKeys: string[] = mailboxId
        ? [mailboxId]
        : [getUserConfiguration().SessionSettings.LogonEmailAddress];

    const userMailboxInfo = getUserMailboxInfo(mailboxId);

    groups.forEach((group: _CalendarGroup) => {
        calendarIdToChangeKeyMapping[group.ItemId.Id] = group.ItemId.ChangeKey;

        let groupEx = {
            ...group,
            id: { id: group.GroupId, mailboxInfo: userMailboxInfo },
        };

        const groupKey = getCalendarGroupKey(userMailboxInfo.mailboxId, group.GroupId);
        calendarGroupMapping[groupKey] = groupEx;
        group.Calendars.forEach(calendarEntry => {
            if (shouldAddCalendarToCache(calendarEntry, calendarKeys)) {
                let entryId = calendarEntry.ItemId.Id;
                let calcFolderId = getCalculatedFolderId(calendarEntry).Id;

                if (calendarEntry.CalendarFolderType == CalendarFolderTypeEnum.DefaultCalendar) {
                    defaultCalendar = {
                        id: { id: entryId, mailboxInfo: userMailboxInfo },
                        calculatedFolderId: calcFolderId,
                        displayName: getCalendarDisplayName(calendarEntry),
                        colorScheme: null,
                    };
                }

                let calendarEntryEx = {
                    ...calendarEntry,
                    id: { id: entryId, mailboxInfo: userMailboxInfo },
                };

                // Do not override any existent mapping.
                // One case it protects for is when user shares its own calendar with himself.
                !calendarEntryMapping[entryId] && (calendarEntryMapping[entryId] = calendarEntryEx);
                !folderIdMapping[calcFolderId] &&
                    (folderIdMapping[calcFolderId] = {
                        id: calendarEntry.ItemId.Id,
                        mailboxInfo: userMailboxInfo,
                    });

                !calendarIdToChangeKeyMapping[entryId] &&
                    (calendarIdToChangeKeyMapping[entryId] = calendarEntry.ItemId.ChangeKey);
            }
        });
    });

    folders.forEach(folder => {
        // As we are not supporting all calendars for now in client e.g. Group, schedule etc.
        // so for a particular folder there will be no corresponding mapping to calendar.
        // Hence we check if there is a corresponding calendar for a folder, only then
        // add the mapping from calendar to that folder.
        const calendarId = folderIdMapping[folder.FolderId.Id];

        if (calendarId) {
            calendarFolderMapping[calendarId.id] = folder;
        }
    });

    return {
        defaultCalendar: defaultCalendar,
        calendarEntryMapping: calendarEntryMapping,
        calendarFolderMapping: calendarFolderMapping,
        folderIdMapping: folderIdMapping,
        calendarGroupMapping: calendarGroupMapping,
        calendarIdToChangeKeyMapping: calendarIdToChangeKeyMapping,
    };
}
